import { render, staticRenderFns } from "./stockInquiry.vue?vue&type=template&id=0d6c321b&scoped=true&"
import script from "./stockInquiry.vue?vue&type=script&lang=js&"
export * from "./stockInquiry.vue?vue&type=script&lang=js&"
import style0 from "./stockInquiry.vue?vue&type=style&index=0&id=0d6c321b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6c321b",
  null
  
)

component.options.__file = "stockInquiry.vue"
export default component.exports